export default from './Chat';



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/index.js